import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const MainLayout = () => {
  return (
    <div>
      <header className="mb-[24px]">
        <Navbar />
      </header>
      <section className="container px-[20px] md:px-0 md:max-w-[1000px] md:m-auto">
        <Outlet />
      </section>
    </div>
  );
};
export default MainLayout;
